exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".weekday {\n}\n\n.holiday {\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar-derogations-user/calendar-derogations-user.component.css
// module id = 320
// module chunks = 0